// import moment from 'moment';
import 'magnific-popup';
import './insta.js'
import './store.js' 
jQuery( document ).ready(function($) {
  // Popup
  $('.mfp-image').magnificPopup({
    type: 'image'
  });
  $('.mfp-inline').magnificPopup({
    type: 'inline'
  });
  if(window.location.hash) {
    console.log(window.location.hash.substring(1));
  } else {
    if ($('#popup').length){
      $.magnificPopup.open({
        items: {
          src: '#popup',
          type: 'inline'
        }
      })
    }
  }
  // Mobile menu
  $('.menu-trigger').click(function(){
      $('.menu').toggleClass('active')
      $(this).toggleClass('active')
  })
  // Music slider
  $('.music-slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    variableWidth: true,
    prevArrow:'<button type="button" class="slick-prev"><i class="fas fa-arrow-alt-circle-left"></i></button>',
    nextArrow:'<button type="button" class="slick-next"><i class="fas fa-arrow-alt-circle-right"></i></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          variableWidth: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });
  // Tour
  // $.ajax( {
  //   url: 'https://rest.bandsintown.com/artists/Cain/events?app_id=45PRESS_cain',
  //   method: 'GET',
  //   dataType: 'json',
  //   xhrFields: {
  //       withCredentials: false
  //   },
  //   error: () => {
  //   },
  //   success: data => {
  //       const events = $( '#events' );
  //       let html = '';
  //       if ( data.length ) {
  //           for ( let event of data ) {
  //               const event_location = typeof event.region !== 'undefined' ? event.venue.city + ', ' + event.venue.region : event.venue.city + ', ' + event.venue.country;
  //               html += '<div class="event" data-bit-id="' + event.id + '">';
  //               html += '<div class="date">' + moment( event.datetime ).format( 'ddd MMM DD @h:mm A' ) + '</div>';
  //               html += '<div class="venue">' + event.venue.name + '</div>';
  //               html += '<div class="location">' + event.venue.city + ' ' + event.venue.region + ', ' + event.venue.country + '</div>';
  //               html += '<a href="' + event.url + '" target="_blank" class="btn">Tickets</a>';
  //               html += '</div>';
  //           }
  //           events.html( html );
  //       } else {
  //           events.html( 'No upcoming events.' );
  //       }
  //   }
  // });
  // // more dates
  // $('.btn-more-dates').click(function(){
  //     $('#events').toggleClass('all-events')
  //     if ($(this).html() === 'View more dates'){
  //       $(this).html('View less dates') 
  //     } else {
  //       $(this).html('View more dates') 
  //     }
  // })
  // Videos slider
  $('.video-slider').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    prevArrow:'<button type="button" class="video-prev slick-prev"><i class="fas fa-arrow-alt-circle-left"></i></button>',
    nextArrow:'<button type="button" class="video-next slick-next"><i class="fas fa-arrow-alt-circle-right"></i></button>',
    variableWidth: true,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  });
  // replace thumbnail with embed on click
  const loadVideos = (e) => {
    const videoCode = e.getAttribute('videoCode')
    const videoThumbnail = `<img src="//img.youtube.com/vi/${videoCode}/0.jpg" alt="video thumbnail"><i class="fas fa-play"></i>`
      e.innerHTML = videoThumbnail
    e.addEventListener('click', () =>{
      const videoEmbed = `<iframe width="560" height="315" src="https://www.youtube.com/embed/${videoCode}?rel=0&enablejsapi=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      e.innerHTML = videoEmbed
      e.querySelector('iframe').addEventListener('load', function(iframe){
        iframe.currentTarget.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'playVideo' }), '*');
      });
    })
  }
  const allVideos = document.querySelectorAll('.video-slide')
  allVideos.forEach(loadVideos)
  // Pause prev video
  var pauseAllYouTubeVideos = () => { 
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => { 
      iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', 
    func: 'pauseVideo' }), '*');
   });
  }
  document.querySelector('.video-next').addEventListener('click', pauseAllYouTubeVideos)
  document.querySelector('.video-prev').addEventListener('click', pauseAllYouTubeVideos)


  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  if (isIOS()){
    
    $('body').addClass('ios')
  }
});